import ApiClient from "../ApiClient";

const appId = process.env.REACT_APP_DEFAULT_APP_ID; // appId per login/session

const PaymentService = {

  // 1 Create Razorpay Order
  async createOrder(payload,agreeToEventUpdates) {
    const resp = await ApiClient.post(`/payments/create-order?agreeToEventUpdates=${agreeToEventUpdates}`, payload);
    return resp;
  },

  // 2 Verify Razorpay Payment
  async verifyPayment(payload) {
    const resp = await ApiClient.post("/payments/verify-payment", payload);
    return resp;
  },

  // 3 Refund Payment
  async refundPayment(payload) {
    const resp = await ApiClient.post("/payments/refund-payment", payload);
    return resp;
  }

};

export default PaymentService;
